import Input from "components/atoms/input/Input";
import { SearchParams } from "./OperationContainer";
import SelectComponent from "components/atoms/select/SelectComponent";
import { getTimeZoneOptions } from "utils/timeUtil";
import { Option } from "utils/options";
import {
  FilterItem,
  FilterItemSearchBtn,
  Label,
  SearchFilterContainer,
  SearchFilterRow,
} from "./SearchFilterStyled";
import { menuOptions } from "./menus";
import BigButton from "components/atoms/buttons/BigButton";
import InputDate from "components/atoms/calendar/InputDate";

const timezoneOptions: Option[] = getTimeZoneOptions();

type SearchFilterType = {
  searchParams: SearchParams;
  onClickSearch: () => void;
  onSearchParamChange: (name: string, value: any) => void;
};

export const SearchFilter = ({
  onClickSearch,
  onSearchParamChange,
  searchParams,
}: SearchFilterType) => {
  return (
    <SearchFilterContainer>
      <SearchFilterRow>
        <FilterItem className="organizationid">
          <Label>Organization ID</Label>
          <Input
            name="accountNumber"
            onChange={(e: any) =>
              onSearchParamChange(e.target.name, e.target.value)
            }
            placeholder="Organization id"
            data-testid="manager-operation-manager-operation-manager-account-number-search-param-change"
          />
        </FilterItem>

        <FilterItem className="useremail">
          <Label>User Email</Label>
          <Input
            name="username"
            onChange={(e: any) =>
              onSearchParamChange(e.target.name, e.target.value)
            }
            placeholder="Please enter an email"
            data-testid="manager-operation-manager-operation-manager-username-search-param-change"
          />
        </FilterItem>

        <FilterItem className="menu">
          <Label>Menu</Label>
          <SelectWrapper
            defaultValue={menuOptions[0]?.value}
            value={searchParams.page}
            onChange={(value: any) => onSearchParamChange("page", value)}
            options={menuOptions}
            placeholder="Menu"
            data-testid="manager-operation-manager-operation-manager-selects-change-menu"
          />
        </FilterItem>

        <FilterItem className="timezone">
          <Label>Timezone</Label>
          <SelectComponent
            defaultValue={searchParams.timezone}
            value={searchParams.timezone}
            onChange={(value: string) => onSearchParamChange("timezone", value)}
            options={timezoneOptions}
            placeholder="Select Timezone"
            data-testid="manager-operation-manager-selects-change-timezone"
          />
        </FilterItem>

        <FilterItem className="start">
          <Label>Date Time</Label>
          <InputDate
            value={[searchParams.startTime, searchParams.endTime]}
            onChange={(value) => {
              onSearchParamChange("startTime", value[0]);
              onSearchParamChange("endTime", value[1]);
            }}
            mode="range"
            timezone={searchParams.timezone}
            allowTime={true}
            required={true}
            data-testid="manager-operation-manager-operation-manager-input-date-change"
          />
        </FilterItem>

        <FilterItemSearchBtn className="submit">
          <BigButton
            label="Search"
            onClickBtn={onClickSearch}
            data-testid="manager-operation-manager-operation-manager-button-click-search"
          />
        </FilterItemSearchBtn>
      </SearchFilterRow>
    </SearchFilterContainer>
  );
};

const SelectWrapper = (props: any) => {
  return (
    <SelectComponent
      defaultValue={menuOptions[0]?.value}
      value={props.value}
      onChange={props.onChange}
      options={props.options}
      placeholder={props.placeholder}
      data-testid="manager-operation-manager-operation-manager-selects-change"
    />
  );
};
